export type FileCategory =
  | 'image'
  | 'audio'
  | 'video'
  | 'text'
  | 'pdf'
  | 'spreadsheet'
  | 'presentation'
  | 'archive'
  | 'code';

export const FORMAT_TO_CATEGORY: Record<string, FileCategory> = {
  // MIME type wildcards
  'image/*': 'image',
  'audio/*': 'audio',
  'video/*': 'video',
  'text/*': 'text',
  // MIME type prefixes (for prefix-based matching)
  'image/': 'image',
  'audio/': 'audio',
  'video/': 'video',
  // Specific MIME types
  'application/pdf': 'pdf',
  'application/msword': 'text',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'text',
  'application/vnd.ms-excel': 'spreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'spreadsheet',
  'application/vnd.ms-powerpoint': 'presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'presentation',
  'application/zip': 'archive',
  'application/x-zip-compressed': 'archive',
  'application/x-tar': 'archive',
  'application/gzip': 'archive',
  'application/x-gzip': 'archive',
  'application/x-bzip2': 'archive',
  'application/x-rar-compressed': 'archive',
  'application/x-7z-compressed': 'archive',
  'application/json': 'code',
  'application/xml': 'code',
  'application/javascript': 'code',
  'text/html': 'code',
  'text/css': 'code',
  'text/javascript': 'code',
  'text/typescript': 'code',
  'text/plain': 'text',
  'text/csv': 'spreadsheet',
  'text/markdown': 'text',
  // File extensions — images
  '.jpg': 'image',
  '.jpeg': 'image',
  '.png': 'image',
  '.gif': 'image',
  '.webp': 'image',
  '.svg': 'image',
  '.bmp': 'image',
  '.ico': 'image',
  '.tiff': 'image',
  '.tif': 'image',
  '.avif': 'image',
  '.heic': 'image',
  // File extensions — audio
  '.mp3': 'audio',
  '.wav': 'audio',
  '.ogg': 'audio',
  '.flac': 'audio',
  '.aac': 'audio',
  '.m4a': 'audio',
  '.wma': 'audio',
  '.opus': 'audio',
  // File extensions — video
  '.mp4': 'video',
  '.avi': 'video',
  '.mov': 'video',
  '.mkv': 'video',
  '.webm': 'video',
  '.flv': 'video',
  '.wmv': 'video',
  '.m4v': 'video',
  '.ogv': 'video',
  // File extensions — text/documents
  '.txt': 'text',
  '.doc': 'text',
  '.docx': 'text',
  '.rtf': 'text',
  '.md': 'text',
  '.odt': 'text',
  // File extensions — pdf
  '.pdf': 'pdf',
  // File extensions — spreadsheets
  '.xlsx': 'spreadsheet',
  '.xls': 'spreadsheet',
  '.csv': 'spreadsheet',
  '.ods': 'spreadsheet',
  '.tsv': 'spreadsheet',
  // File extensions — presentations
  '.pptx': 'presentation',
  '.ppt': 'presentation',
  '.odp': 'presentation',
  // File extensions — archives
  '.zip': 'archive',
  '.tar': 'archive',
  '.gz': 'archive',
  '.rar': 'archive',
  '.7z': 'archive',
  '.bz2': 'archive',
  '.xz': 'archive',
  // File extensions — code
  '.js': 'code',
  '.ts': 'code',
  '.html': 'code',
  '.htm': 'code',
  '.css': 'code',
  '.scss': 'code',
  '.json': 'code',
  '.xml': 'code',
  '.py': 'code',
  '.java': 'code',
  '.cpp': 'code',
  '.c': 'code',
  '.rb': 'code',
  '.php': 'code',
  '.sh': 'code',
  '.yaml': 'code',
  '.yml': 'code',
};

export const CATEGORY_ICONS: Record<FileCategory, string> = {
  image: 'remix:Media/image-line',
  audio: 'remix:Media/music-2-fill',
  video: 'remix:Document/file-video-line',
  text: 'remix:Document/file-text-line',
  pdf: 'remix:Document/file-pdf-2-line',
  spreadsheet: 'remix:Document/file-list-2-line',
  presentation: 'remix:Document/file-ppt-2-line',
  archive: 'remix:System/file-zip-line',
  code: 'remix:Document/file-code-line',
};

export const MIME_PREFIXES: { prefix: string; category: FileCategory }[] = [
  { prefix: 'image/', category: 'image' },
  { prefix: 'audio/', category: 'audio' },
  { prefix: 'video/', category: 'video' },
  { prefix: 'text/', category: 'text' },
];
